import type { ExerciseQueueSort } from 'api/rest/exerciseQueues/exerciseQueues.types';
import type { Option } from 'components/_inputs/_types/Option';

export const ONGO_INIT_FORM_ID = 'ongo-initialize-form';

export const SORT_OPTIONS: { value: ExerciseQueueSort; label: string }[] = [
  { value: 'section_index', label: 'Według programu' },
  { value: 'random', label: 'Losowo' },
  { value: 'hardest', label: 'Od najtrudniejszych' },
  { value: 'easiest', label: 'Od najłatwiejszych' },
];

export const SORT_SELECT_OPTIONS: Option[] = SORT_OPTIONS.map(o => ({ value: o.value, label: o.label }));
